import { createApiClient } from '@pomoshnik/shared';
import { TEST_DEPLOY_BYPASS } from './featureFlags';

/**
 * Singleton API клиент. baseUrl = текущий origin — фронт ходит к относительным
 * `/api/...`, MSW в dev/test их перехватывает, реальный Edge будет принимать
 * после Phase 9+.
 */

/**
 * TEMPORARY mock JWT для Phase 7. Реальный JWT появится в Phase 9 (auth flow).
 * См. BACKLOG B-011.
 *
 * **PROD-guard:** функция бросает ошибку при `import.meta.env.PROD` — это
 * страховка чтобы mock-токен НЕ попал в production build. При vite build
 * для prod, любой запрос с auth=true моментально упадёт с этой ошибкой,
 * и мы заметим прежде чем выпустить сборку.
 *
 * **TEST_DEPLOY_BYPASS (Phase F4):** `VITE_TEST_DEPLOY=true` ослабляет guard,
 * чтобы тест-деплой на Cloudflare Pages (HTTPS-проверка WebShare) принимал
 * unauthenticated user с mock JWT. Default `false` — production safety
 * сохранён. См. `featureFlags.ts` TEST_DEPLOY_BYPASS.
 *
 * TODO(auth): заменить на `() => useAuthStore.getState().jwt` после Phase 9.
 */
const MOCK_AUTH_TOKEN = 'mock-jwt-mvp';

/**
 * @internal Экспорт сделан только для unit-теста guard'а
 * (`apiClient.test.ts`). НЕ импортировать в product-коде — используй `apiClient`.
 */
export function mockAuthToken(): string | null {
  if (import.meta.env.PROD && !TEST_DEPLOY_BYPASS) {
    throw new Error(
      '[apiClient] mock authToken cannot run in production. ' +
        'Replace with real JWT from auth store before production build. ' +
        'See BACKLOG B-011 and apiClient.ts.',
    );
  }
  return MOCK_AUTH_TOKEN;
}

export const apiClient = createApiClient({
  baseUrl: typeof window !== 'undefined' ? window.location.origin : 'http://localhost',
  authToken: mockAuthToken,
});
